export function LoadingSkeleton() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-8" aria-busy="true" aria-live="polite">
      <div className="mb-6 h-8 w-3/4 animate-pulse rounded bg-slate-200" />
      <div className="mb-4 h-4 w-1/2 animate-pulse rounded bg-slate-200" />
      <div className="space-y-2">
        <div className="h-16 animate-pulse rounded bg-slate-200" />
        <div className="h-16 animate-pulse rounded bg-slate-200" />
        <div className="h-16 animate-pulse rounded bg-slate-200" />
      </div>
    </div>
  );
}
